import {
  ARC_END_ANGLE,
  ARC_START_ANGLE,
  GAUGE_VERTICAL_DEFAULT_OFFSET,
  GAUGE_VERTICAL_SMALL_OFFSET,
  MIN_MAX_LABEL_RESERVED_HEIGHT_IN_PX,
  MIN_MAX_PADDING,
} from '../constants.js';
import { useGaugeChartAspectRatio } from './useGaugeChartAspectRatio.js';
import { useGaugeChartSizeContext } from './useGaugeChartSizeContext.js';
import { polarToCartesian } from '../utils/polar-to-cartesian.js';

export const useGaugeChartMinMaxLabelsPosition = () => {
  const { arcMiddleRadius } = useGaugeChartAspectRatio();
  const dimensions = useGaugeChartSizeContext();
  const width = dimensions?.width ?? 0;
  const height = dimensions?.height ?? 0;

  const minLabelPosition = polarToCartesian(arcMiddleRadius, ARC_START_ANGLE);
  const maxLabelPosition = polarToCartesian(arcMiddleRadius, ARC_END_ANGLE);

  const verticalOffset =
    height > width
      ? height * GAUGE_VERTICAL_SMALL_OFFSET
      : height * GAUGE_VERTICAL_DEFAULT_OFFSET;

  // Space from SVG center to bottom edge, minus the arc endpoint y, minus reserved text height.
  // Clamped to [0, MIN_MAX_PADDING] so the offset never exceeds the default at large sizes.
  const availableAfterArcEnd = height / 2 - verticalOffset - maxLabelPosition.y;
  const minMaxPadding = Math.min(
    MIN_MAX_PADDING,
    Math.max(0, availableAfterArcEnd - MIN_MAX_LABEL_RESERVED_HEIGHT_IN_PX),
  );

  return {
    minLabelPosition,
    maxLabelPosition,
    minMaxPadding,
  };
};
